import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ToastData } from '@models/business/toast-data.model';
import { ToastTypes } from '@core/enums/toast-types.enum';
import { DeleteMessageResponseDto } from 'src/app/camms-risk/models/delete-message-response';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    //#region Private declarations
    private obj: ToastData = {};
    //#endregion

    //#region Public declarations
    public toastSubject$ = new BehaviorSubject<ToastData>(this.obj);
    public toast$ = this.toastSubject$.asObservable();
    //#endregion

    //#region Public methods
    public success(message: string, width?: number): void {
        this.setData(ToastTypes.Success, message, width);
        this.toastSubject$.next(this.obj);
        this.obj = {};
    }

    public danger(message?: string, width?: number): void {
        this.setData(ToastTypes.Danger, message, width);
        this.toastSubject$.next(this.obj);
        this.obj = {};
    }

    public alert(message?: string, errors?: string[], width?: number): void {
        this.setData(ToastTypes.Alert, message, width);
        if (errors != null && errors.length > 0) {
            this.obj.errors = errors;
        }
        this.toastSubject$.next(this.obj);
        this.obj = {};
    }

    public info(message?: string, width?: number): void {
        this.setData(ToastTypes.Info, message, width);
        this.toastSubject$.next(this.obj);
        this.obj = {};
    }
    //#endregion

    //#region Private methods
    private setData(type: ToastTypes, message?: string, width: number = 500): void {
        this.obj.type = type;
        this.obj.message = message;
        this.obj.hedearmessage = type;
        this.obj.width = width;
    }
    //#endregion
    public deleteAlert(
        message?: string,
        errors?: DeleteMessageResponseDto[],
    ): void {
        this.setData(ToastTypes.Alert, message);
        if (errors != null && errors.length > 0) {
            this.obj.descriptiveDeleteErrors = errors;
        }
        this.toastSubject$.next(this.obj);
        this.obj = {};
    }
}
